// Fixed dollar amounts (discount configs, "$X off" claims, sale overrides)
// are USD-denominated, so they only render in the US market — else null.
export const usdOnly = <T>(value: T, currencyCode: string): T | null =>
  currencyCode === 'USD' ? value : null;
